import { render } from "./AddClientModal.vue?vue&type=template&id=4c5318b1&ts=true"
import script from "./AddClientModal.vue?vue&type=script&lang=ts"
export * from "./AddClientModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__